import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
          <XCircle className="mx-auto mb-6 text-red-600" size={80} data-testid="cancel-icon" />
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4" data-testid="cancel-title">
            Paiement annulé
          </h1>
          
          <p className="text-gray-600 mb-6">
            Votre paiement a été annulé. Aucun montant n'a été débité.
          </p>

          <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
            <p className="text-orange-800 text-sm">
              Vos articles sont toujours dans votre panier. Vous pouvez recommencer votre commande à tout moment.
            </p>
          </div>

          <div className="space-y-3">
            <Link
              to="/cart"
              className="block w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition"
              data-testid="back-to-cart-btn"
            >
              Retour au panier
            </Link>
            
            <Link
              to="/"
              className="block w-full border border-gray-300 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-50 transition"
            >
              Continuer mes achats
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;